import AbTester from '@lessonnine/ab-tester.api.js';

import awsApiClient from './awsApiClient';

export default (): AbTester.ExperimentResult =>
  new AbTester.ExperimentResult(awsApiClient());
